import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      service: 'service/service',
      serviceAddons: 'service/addons',
      serviceMarginTypes: 'service/marginTypes',
      serviceRetouchTypes: 'service/retouchTypes',
      orderImages: 'order/images',
      orderAddOns: 'order/addOns',
      serviceComponents: 'service/components',
      orderDeliveryTimeId: 'order/deliveryTimeId',
      serviceDeliveryTimes: 'service/deliveryTimes',
      serviceComplexities: 'service/complexities',
      orderCoupon: 'order/coupon',
      complexityKeysInfo: 'order/complexityKeysInfo',
      orderServiceComponents: 'order/serviceComponents',
    }),
    complexityInfo() {
      return this.complexityKeysInfo.filter(item => item.total > 0);
    },
  },
  methods: {
    getRetouchTypeTitle(id) {
      let type = this.serviceRetouchTypes.filter(type => {
        return type.id === id;
      });

      return type[0].title;
    },
    getMarginTypeTitle(id) {
      let type = this.serviceMarginTypes.filter(type => {
        return type.id === id;
      });

      return type[0].title;
    },
    getImageComplexityPrice() {
      let total = 0;
      this.complexityKeysInfo.map((info) => {
        total = total + info.total * info.price;
      });

      return total;
    },
    hasAddons() {
      return Object.keys(this.orderAddOns).length > 0;
    },
    getAddOnsPrice() {
      let price = 0;
      let length = this.orderImages.length;

      if (Object.keys(this.orderAddOns).length !== 0) {
        Object.keys(this.orderAddOns).forEach((value, key) => {
          if (value === 'websizes') {
            price = price + this.serviceAddons.websizes.price * length;
          }

          if (value === 'margin') {
            let typePrice = 0;

            this.serviceMarginTypes.map((type) => {
              if (key.marginTypeId === type.id) {
                typePrice = type.price;
              }
            });

            price = price + typePrice * length;
          }

          if (value === 'adjustment') {
            price = price + this.serviceAddons.adjustment.price * length;
          }

          if (value === 'retouch') {
            let retouchPrice = 0;

            this.serviceRetouchTypes.map((retouch) => {
              if (this.orderAddOns.retouch === retouch.id) {
                retouchPrice = retouch.price;
              }
            });

            price = price + retouchPrice * length;
          }
        });
      }

      return price;
    },
    getOrderServiceComponentsPrice() {
      let price = 0;
      if (this.orderServiceComponents.length === 0) {
        return price;
      }

      this.orderServiceComponents.map(component => {
        let data = this.getOrderComponentNameAndPrice(component);
        price = price + data.price;
      });

      return price;
    },
    getSubTotalPrice() {
      let price = 0;

      price =
        this.getImageComplexityPrice() +
        this.getOrderServiceComponentsPrice() +
        this.getAddOnsPrice();

      return price;
    },
    getDiscountPrice() {
      let price = 0;

      if (this.orderCoupon) {
        if (this.orderCoupon.is_actual) {
          price = this.orderCoupon.value;
        } else {
          price = this.getDeliveryTimePrice() * (this.orderCoupon.value / 100);
        }
      }

      return price;
    },
    getDeliveryTimePrice() {
      let price = this.getSubTotalPrice();
      let deliveryTimeFactor = 1;

      if (this.orderDeliveryTimeId) {
        this.serviceDeliveryTimes.map((time) => {
          if (time.id === this.orderDeliveryTimeId) {
            deliveryTimeFactor = time.factor;
          }
        });
      }

      return price * deliveryTimeFactor;
    },

    getDeliveryTimeExtraPrice() {
      return this.getDeliveryTimePrice() -  this.getSubTotalPrice();
    },

    getTotalPrice() {
      let price = 0;

      price = this.getDeliveryTimePrice() - this.getDiscountPrice();

      return price;
    },
    //
    getComplexityTotal(id) {
      let count = 0;
      this.orderImages.map((image) => {
        if (image.complexityId === id) {
          count += 1;
        }
      });

      return count;
    },
    // getShowdowName() {
    //   let name;

    //   this.serviceShadows.filter((shodow) => {
    //     if (shodow.id === this.orderShadowId) {
    //       name = shodow.title;
    //     }
    //   });

    //   return name;
    // },
    // getDeliveryTypeName() {
    //   let name;

    //   this.serviceDeliveryTypes.filter((deliveryType) => {
    //     if (deliveryType.id === this.orderDeliveryTypeId) {
    //       name = deliveryType.title;
    //     }
    //   });

    //   return name;
    // },
    // getDeliveryFormatNames() {
    //   let name = [];

    //   this.serviceDeliveryFormats.filter((deliveryFormat) => {
    //     if (this.orderDeliveryFormatIds.includes(deliveryFormat.id)) {
    //       name.push(deliveryFormat.title);
    //     }
    //   });

    //   return name.join(', ');
    // },
    getDeliveryTimeName() {
      let name;

      this.serviceDeliveryTimes.filter((deliveryTime) => {
        if (deliveryTime.id === this.orderDeliveryTimeId) {
          name = deliveryTime.title;
        }
      });

      return name;
    },
    getOrderComponentName(orderComponent) {
      let data = this.getOrderComponentNameAndPrice(orderComponent);
      return data.name;
    },
    getOrderComponentChoices(orderComponent) {
      const component = this.serviceComponents.find(serviceComponent => {
        return serviceComponent.id === orderComponent.id;
      });

      return component.choices.filter(item => {
        return !!orderComponent.choices.filter(id => item.id === id).length;
      })
    },
    getOrderComponentNameAndPrice(orderComponent) {
      let data = {
        name: '',
        price: 0,
      };

      let component = null;
      let length = this.orderImages.length;
      this.serviceComponents.map(serviceComponent => {
        if (serviceComponent.id === orderComponent.id) {
          component = serviceComponent;
        }
      });

      data.name = component.title;

      orderComponent.choices.map(orderComponentChoice => {
        component.choices.map(componentChoice => {
          if (orderComponentChoice === componentChoice.id) {
            data.price = data.price + (componentChoice.price * length);
          }
        });
      });

      return data;
    },
    getDeliveryTypeAndFormatPrice() {
      if (this.service === null) {
        return 0;
      }

      let price = 0;
      let length = this.orderImages.length;

      this.serviceDeliveryTypes.map((type) => {
        if (type.id === this.orderDeliveryTypeId) {
          price = price + type.price * length;
        }
      });

      this.serviceDeliveryFormats.map((format) => {
        if (this.orderDeliveryFormatIds.includes(format.id)) {
          price = price + format.price * length;
        }
      });

      return price;
    },
    edit(name) {
      this.$router.push({
        name: name,
        params: { slug: this.service.slug },
      });
    },
  },
};
